import { useState, useEffect } from "react";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  Font,
  StyleSheet,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";

import { FontRegister, DocStyles, LogoTavad } from "./DocStyles";

import { FormatDate } from './FormatDate';

import { useLoaderData, useParams } from "react-router-dom";

import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

export function FactTratField({
  updateData,
  autoEspecialistaData,
  autoPacienteData,
  savedData,
}) {
  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  let especialistaFullName = autoEspecialistaData
    ? autoEspecialistaData?.first_name + " " + autoEspecialistaData?.last_name
    : undefined;
  let pacienteFullName = autoPacienteData
    ? autoPacienteData?.first_name + " " + autoPacienteData?.last_name
    : undefined;
  let pacienteFullDireccion =
    autoPacienteData?.meta?.direccion +
    ", " +
    autoPacienteData?.meta?.direccion_num +
    ", " +
    autoPacienteData?.meta?.direccion_piso;

  const [docResp, setDocResp] = useState(
    savedData?.docResp ? savedData?.docResp : especialistaFullName
  );
  const [docFecha, setDocFecha] = useState(
    savedData?.docFecha ? savedData?.docFecha : todayDate
  );
  const [docPacie, setDocPacie] = useState(
    savedData?.docPacie ? savedData?.docPacie : pacienteFullName
  );
  const [docDni, setDocDni] = useState(
    savedData?.docDni ? savedData?.docDni : autoPacienteData?.meta?.dni
  );
  const [docDirecc, setDocDirecc] = useState(
    savedData?.docDirecc ? savedData?.docDirecc : pacienteFullDireccion
  );
  const [docCodPost, setDocCodPost] = useState(
    savedData?.docCodPost
      ? savedData?.docCodPost
      : autoPacienteData?.meta?.direccion_cp
  );
  const [docPobl, setDocPobl] = useState(
    savedData?.docPobl
      ? savedData?.docPobl
      : autoPacienteData?.meta?.direccion_ciudad
  );
  const [docProv, setDocProv] = useState(
    savedData?.docProv
      ? savedData?.docProv
      : autoPacienteData?.meta?.direccion_provincia
  );
  const [docNumFact, setDocNumFact] = useState(
    savedData?.docNumFact ? savedData?.docNumFact : undefined
  );
  const [docImport, setDocImport] = useState(
    savedData?.docImport ? savedData?.docImport : undefined
  );

  let data = {
    docResp: docResp,
    docFecha: docFecha,
    docPacie: docPacie,
    docDni: docDni,
    docDirecc: docDirecc,
    docCodPost: docCodPost,
    docPobl: docPobl,
    docProv: docProv,
    docNumFact: docNumFact,
    docImport: docImport,
  };

  useEffect(() => {
    updateData(data);
  }, [
    docResp,
    docFecha,
    docPacie,
    docDni,
    docDirecc,
    docCodPost,
    docPobl,
    docProv,
    docNumFact,
    docImport,
  ]);

  // Data for docx generator
  const [showDocxLink, setShowDocxLink] = useState(false);

  const generateDocx = async () => {
    try {
      const response = await fetch(
        "https://app.tavad.com/documentacion-templates/FactTrat.docx"
      );
      const blob = await response.blob();
      const arrayBuffer = await new Response(blob).arrayBuffer();

      const zip = new PizZip(arrayBuffer);
      const doc = new Docxtemplater(zip, {
        nullGetter() {
          return "XXXXXXXXX";
        },
      });

      doc.setData({
        responsable: docResp,
        date: FormatDate(docFecha),
        paciente: docPacie,
        dni: docDni,
        direccion: docDirecc,
        codPostal: docCodPost,
        poblacion: docPobl,
        provincia: docProv,
        numFactura: docNumFact,
        impFactura: docImport,
      });

      doc.render();
      const output = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      saveAs(output, "factura-tratamiento.docx");
    } catch (error) {
      console.error("Error al generar el documento .docx", error);
    }
  };

  useEffect(() => {
    updateData(data);
    setShowDocxLink(true);
  }, [
    docResp,
    docFecha,
    docPacie,
    docDni,
    docDirecc,
    docCodPost,
    docPobl,
    docProv,
    docNumFact,
    docImport,
  ]);
  return (
    <>
      <div className='docFormContainer'>
      <div className="grid--2col">
        {/* <div className='field'>
          <label htmlFor='docResp'>Responsable</label>
          <div className='control'>
            <input
              className='input'
              id='docResp'
              required
              type='text'
              value={docResp}
              onChange={(e) => setDocResp(e.target.value)}
            />
          </div>
        </div> */}
        <div className='field'>
          <label htmlFor='docFecha'>Fecha</label>
          <div className='control'>
            <input
              className='input'
              id='docFecha'
              required
              type='date'
              value={docFecha}
              onChange={(e) => setDocFecha(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docNumFact'>Número de factura</label>
          <div className='control'>
            <input
              className='input'
              id='docNumFact'
              required
              type='text'
              value={docNumFact}
              onChange={(e) => setDocNumFact(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docPacie'>Paciente</label>
          <div className='control'>
            <input
              className='input'
              id='docPacie'
              required
              type='text'
              value={docPacie}
              onChange={(e) => setDocPacie(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docDni'>DNI Paciente</label>
          <div className='control'>
            <input
              className='input'
              id='docDni'
              required
              type='text'
              value={docDni}
              onChange={(e) => setDocDni(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docDirecc'>Dirección</label>
          <div className='control'>
            <input
              className='input'
              id='docDirecc'
              required
              type='text'
              value={docDirecc}
              onChange={(e) => setDocDirecc(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docCodPost'>Código Postal</label>
          <div className='control'>
            <input
              className='input'
              id='docCodPost'
              required
              type='text'
              value={docCodPost}
              onChange={(e) => setDocCodPost(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docPobl'>Población</label>
          <div className='control'>
            <input
              className='input'
              id='docPobl'
              required
              type='text'
              value={docPobl}
              onChange={(e) => setDocPobl(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docProv'>Provincia</label>
          <div className='control'>
            <input
              className='input'
              id='docProv'
              required
              type='text'
              value={docProv}
              onChange={(e) => setDocProv(e.target.value)}
            />
          </div>
        </div>
        <div className='field'>
          <label htmlFor='docImport'>Importe del tratamiento</label>
          <div className='control'>
            <input
              className='input'
              id='docImport'
              required
              type='number'
              value={docImport}
              onChange={(e) => setDocImport(e.target.value)}
            />
          </div>
        </div>
        </div>
      </div>
      <div className='btn-dwnld'>
        

        {showDocxLink && (
          <a className='button is-link' href='#!' onClick={generateDocx}>
            Descargar DOCX
          </a>
        )}
      </div>

      
    </>
  );
}


